module.exports = __webpack_public_path__ + "img/PreOccupationalCleaning_2.f9efeb85.jpg";